import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.jpg";
import FloatingBubbles from "../FloatingBubbles"; 
import AboutContent from "../About/AboutContent";
import Projects from "../Projects/Projects";
import Contact from "../Contact/Contact";
import ResumeLayout from "../Resume/ResumeLayout";
import Github from "../Projects/Github";
import Type from "./Type";

function Home() {
  return (
    <section>
      {/* Home Section */}
      <Container fluid className="home-section" id="home">
        <FloatingBubbles />
        <Container className="home-content">
          <Row className="align-items-center">
            {/* Image Column First */}
            <Col md={12} className="text-center" style={{ marginBottom: 30 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="home-avatar"
                style={{
                  width: "280px",
                  height: "280px",
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />
            </Col>

            {/* Text Content Below */}
            <Col md={12} className="home-header text-center">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi there!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'm
                <strong className="main-name"> Yaoyi Wang</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "center" }}>
                <Type />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* About Section */}
      <div id="about" style={{ scrollMarginTop: '70px', width: '100%' }}>
        <AboutContent />
      </div>

      {/* Resume Section */}
      <div id="resume" style={{ scrollMarginTop: '70px', width: '100%' }}>
        <ResumeLayout />
      </div>

      {/* Projects Section */}
      <div id="projects" style={{ scrollMarginTop: '70px', width: '100%' }}>
        <Projects />
        <Github />
      </div>

      {/* Contact Section */}
      <div id="contact" style={{ scrollMarginTop: '70px', width: '100%' }}>
        <Contact />
      </div>
    </section>
  );
}

export default Home;